import React from "react";

import { FeaturedProductItemProps } from "./types";

import { env } from "~/env";

export const FeaturedProductItem: React.FC<FeaturedProductItemProps> = ({
  product: { handle, image, title },
}) => (
  <div className="featured-product-item">
    <a
      href={`${env(
        "SHOPIFY_SHOP_EQUIPMENTSHARE_COM_BASE_URL"
      )}/products/${handle}`}
    >
      <div className="featured-product-item-img">
        <img src={image} alt="Featured Product" />
      </div>
      <h5>{title}</h5>
    </a>
  </div>
);
